var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 8L60.36 33.04L88 37.08L68 56.56L72.72 84.08L48 71.08L23.28 84.08L28 56.56L8 37.08L35.64 33.04L48 8Z",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgStar;